<template>
	<div class="main-container">
		<div class="col-sm-4 login_container">
			<form @submit.prevent="loginForm()">
				<label>Username</label>
				<div class="form-group">
					<input type="text" class="form-control" v-model="username">
				</div>

				<label>Password</label>
				<div class="form-group"> 
					<input type="password" class="form-control" v-model="password"> 
				</div> 
				
				<button type="submit" class="btn">login</button>
			</form>
			
		</div>
	</div>
</template>

<script>

	import { AUTH_REQUEST } from '@/store/actions/auth'

	export default {
		name: 'login',

		data () {
			return {
				username: '',
				password: ''
			}
		},

		methods: {
			loginForm(){
				const { username, password } = this
				this.$store.dispatch(AUTH_REQUEST, { username, password })
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/scss/style.scss';

	.error_message {
		margin-top: 15px;
	}
	.main-container{
		position: relative;
		min-height: 100vh;
	}
	.login_container{
		position: absolute;
		transform: translate(-50%, -50%);
		top: 50%;
		left: 50%;
	}


</style>